import { useAppSelector } from "../../store/store";
import { AdminRoleLabels } from "../../types/adminRoles";
import { Avatar } from "../../ui";
import "./styles.scss";

const Navbar = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const getAdminRolesText = () => {
    if (!currentUser?.adminRoles || currentUser.adminRoles.length === 0) {
      return "No admin role";
    }
    return currentUser.adminRoles.map((role) => AdminRoleLabels[role]).join(", ");
  };

  return (
    <div className="navbar">
      <div className="left" />
      <div className="user-container">
        <Avatar
          name={`${currentUser?.firstName.at(0) ?? ""} ${currentUser?.lastName?.at(0) ?? ""}`}
          size={34}
          className="navbar-avatar"
        />
        <div className="user-text">
          <p className="name">
            {currentUser?.firstName} {currentUser?.lastName ?? ""}
          </p>
          <p className="role" data-tooltip={getAdminRolesText()}>
            {getAdminRolesText()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
